const URL = '/app_params';

const state = {
  all: [],
  edited: {
    id: null,
    nombre: null,
    valor: null,
    created_at: null,
    updated_at: null,
  },
  selected: {
    id: null,
    nombre: null,
    valor: null,
    created_at: null,
    updated_at: null,
  },
  filters: {
    nombre: null,
  },
  loading: false,
  headers: [
    {
      text: 'Nombre',
      value: 'nombre',
      align: 'center'
    },
    {
      text: 'Valor',
      value: 'valor',
      align: 'center'
    },
  ],
  options: {
    page: 1,
    itemsPerPage: 100,
    sortBy: [],
    sortDesc: []
  },
  itemsLength: null,
}

// GETTERS
const getters = {
  all (state) {
    return state.all
  },
  vigenciaInvierno (state) {
    return state.all.find(item => item.nombre === 'vigencia_invierno')
  },
  vigenciaVerano (state) {
    return state.all.find(item => item.nombre === 'vigencia_verano')
  },
  edited (state) {
    return state.edited
  },
  filters (state) {
    return state.filters
  },
  headers (state) {
    return state.headers
  },
  itemsLength (state) {
    return state.itemsLength
  },
  options (state) {
    return state.options
  },
  loading (state) {
    return state.loading
  },
}

// ACTIONS
const actions = {
  onClearAll ({ commit }) {
    commit('setAll', [])
    commit('setOptions', {
      itemsPerPage: 10,
      page: 1,
      sortBy: [],
      sortDesc: []
    })
    commit('setItemsLength', null)
  },
  onClearEdited ({ commit}) {
    commit('setEdited', {
      id: null,
      nombre: null,
      valor: null,
      created_at: null,
      updated_at: null,
    })
  },
  onClearSelected ({ commit}) {
    commit('setSelected', {
      id: null,
      nombre: null,
      valor: null,
      created_at: null,
      updated_at: null,
    })
  },
  onFetch ({ state, commit }) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      axios.get(URL, {
        params: {
          itemsPerPage: state.options.itemsPerPage,
          page: state.options.page,
          sortBy: state.options.sortBy[0],
          sortDesc: state.options.sortDesc[0] ? 1 : 0,
          nombre: state.filters.nombre,
        }
      })
        .then(response => {
          commit('setAll', response.data)
          commit('setItemsLength', response.data.length)
          if (state.options.page + state.options.itemsPerPage > response.data.length)
            commit('setPage', 1)
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
        .finally(() => {
          commit('setLoading', false)
        })
    })
  },
}

// MUTATIONS
const mutations = {
  setAll (state, payload) {
    state.all = payload.slice()
  },
  setEdited (state, payload) {
    state.edited = Object.assign({}, payload)
  },
  setSelected (state, payload) {
    state.selected = Object.assign({}, payload)
  },
  setFilters (state, payload) {
    state.filters = Object.assign({}, payload)
  },
  setLoading (state, payload) {
    state.loading = payload
  },
  setPage (state, payload) {
    state.options.page = payload
  },
  setItemsPerPage (state, payload) {
    state.options.itemsPerPage = payload
  },
  setItemsLength (state, payload) {
    state.itemsLength = payload
  },
  setOptions (state, payload) {
    state.options = payload
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
